import { jsx as _jsx } from "react/jsx-runtime";
// import { classNames } from 'shared/lib/helpers/classNames/classNames';
import LoaderIcon from 'shared/assets/img/common/preloader-puf.svg';
export var Loader = function (_a) {
    var className = _a.className;
    return (_jsx(LoaderIcon, { className: className }));
};
